import { memo, useState, useRef, useEffect } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import logonBlack from '@/assets/images/logo-black.png'
import logonWhite from '@/assets/images/logo-white.png'
import LoginBtn from './LoginBtn/LoginBtn'
import SvgIcon from '@/components/SvgIcon/SvgIcon'
import { useLoginModal } from '@/store/loginContext'
import { sessionStore } from '@/utils/storage'
import { eventBus } from '@/utils/eventBus'
import './PageNav.less'
const NAV_LIST: any = [
  { label: '首页', url: '/' },
  { label: '开题报告', url: '/thesisTopic/1', icon: 'icon-HOT' },
  { label: '文献综述', url: '/thesisTopic/2' },
  { label: '毕业论文', url: '/thesisTopic/3' },
  { label: '课程论文', url: '/thesisTopic/4' },
  { label: '答辩PPT', url: '/createPPT' },
  { label: '降重', url: '/reduce/6' },
  { label: '降AIGC', url: '/reduce/7' },
  { label: '格式排版', url: '/articleLayout' }
]
const PageNav = ({ history }: any) => {
  const location = useLocation()
  const { showLoginModal } = useLoginModal()
  const [logo, setLogo] = useState(true)
  const [navList, setNavList] = useState(NAV_LIST)
  const [selectNavIndex, setSelectNavIndex] = useState(0)
  const [navClass, setVavClass] = useState('')
  const [animtionClass, setAnimtionClass] = useState('')
  const [animtionClass2, setAnimtionClass2] = useState('')
  const timer = useRef<NodeJS.Timeout | null>(null)
  const headerRef = useRef<HTMLElement | null>(null)
  useEffect(() => {
    const id: any = location.pathname?.slice(-1)
    if (id == 1 || id == 2 || id == 3 || id == 4 || id == 6 || id == 7) {
      onGetType(id)
    } else if (['/createPPT', '/surePPTCatalog', '/selectPPTTheme', '/resulePPT'].includes(location.pathname)) {
      onGetType(5)
    } else if (['/articleLayout', '/selectTemplate', '/layoutResult'].includes(location.pathname)) {
      onGetType(8)
    }
  }, [])
  useEffect(() => {
    if (location.pathname == '/') {
      setSelectNavIndex(0)
      onResetDate()
    }
    if (location.pathname != '/body') {
      setAnimtionClass2('')
    }
  }, [location.pathname])
  useEffect(() => {
    // 监听点击首页创作按钮
    const unsubscribe = eventBus.on('animate-header', () => {
      setAnimtionClass('animate-header')
    })
    return () => unsubscribe()
  }, [])
  useEffect(() => {
    // 监听是否在正文（4 种）页
    const unsubscribe = eventBus.on('body-animate-header', () => {
      const latestData: any = sessionStore.get<any[]>('stepData', [])
      onGetType(latestData.type)
      setAnimtionClass2('body-animate-header')
    })
    return () => unsubscribe()
  }, [])
  useEffect(() => {
    // 监听正文 进入到 ppt/排版
    const unsubscribe = eventBus.on('page-nav-get-type', (type: any) => {
      onGetType(type)
    })
    return () => unsubscribe()
  }, [])
  const onMouseEnter = () => setLogo(false)
  const onMouseLeave = () => setLogo(true)
  const onHandleClick = (item: any, index: number) => {
    if (location.pathname == '/') {
      if (index == 0) {
        scrollToTop()
        return
      }
    }
    const uniToken = localStorage.getItem('uniToken')
    if (!uniToken) {
      showLoginModal({ onOk: () => onGotoNext(item, index) })
      return
    }
    onGotoNext(item, index)
  }
  const onGotoNext = (item: any, index: number) => {
    setAnimtionClass('')
    // setAnimtionClass2('')
    clearStore()
    setSelectNavIndex(index)
    onMouseNavLeave(index)
    history.push(item.url)
  }
  const onMouseNavEnter = () => {
    if (selectNavIndex == 0) return
    onResetDate()
  }
  const onMouseNavLeave = (index = selectNavIndex) => {
    if (index == 0) return
    if (timer.current) clearTimeout(timer.current)
    setVavClass('nav-2')
    setNavList([NAV_LIST[index]])
  }
  const onBackIndex = () => {
    if (location.pathname == '/') {
      scrollToTop()
      return
    }
    clearStore()
    setSelectNavIndex(0)
    onResetDate()
    history.push('/')
  }
  const scrollToTop = () => {
    const root = document.getElementById('root')
    if (root && typeof (root as any).scrollTo === 'function') {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi
      ;(root as any).scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
  const onResetDate = () => {
    setVavClass('')
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => setNavList(NAV_LIST), 100)
  }

  const onHideMb = () => {
    setAnimtionClass('')
  }
  const onGetType = (type: any) => {
    setSelectNavIndex(type)
    onMouseNavLeave(type)
  }
  const clearStore = () => {
    sessionStore.remove('stepData')
    sessionStore.remove('createPPTData')
    sessionStore.remove('reduceData')
    sessionStore.remove('layoutData')
  }
  return (
    <>
      <header ref={headerRef} className={`header ${navClass ? 'header-2' : ''} ${animtionClass} ${animtionClass2}`}>
        <div className={`logo`} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onBackIndex}>
          <img className={logo ? 'show' : 'hide'} src={logonBlack} style={{ zIndex: logo && navClass ? 2 : 1 }} />
          <img className={logo ? 'show' : 'hide'} src={logonWhite} style={{ zIndex: logo && !navClass ? 2 : 1 }} />
          <div className='logo-icon'>
            <i className={`icon-index_home ${logo ? 'hide' : 'show'}`} />
          </div>
        </div>
        <nav className={`nav ${navClass}`} onMouseEnter={onMouseNavEnter} onMouseLeave={() => onMouseNavLeave()}>
          <ul className='list'>
            {navList.map((item: any, index: number) => {
              return (
                <li key={index} className={navList?.length == 1 ? 'active' : ''} onClick={() => onHandleClick(item, index)}>
                  {item.icon && !navClass && <SvgIcon className='icon-tip' href={item.icon} />}
                  {navClass && <i className={`icon-youyou`} />}
                  {item?.label}
                </li>
              )
            })}
          </ul>
        </nav>
        <LoginBtn onHideMb={onHideMb} onGetType={onGetType} />
      </header>
      {animtionClass == 'animate-header' && <div className='animate-header-mb' onClick={onHideMb}></div>}
    </>
  )
}

export default memo(withRouter(PageNav))
